/** Utilidades de UI para prueba SMTP (sin secretos). */

export function isPasswordPlaceholder(password) {
  if (password == null) return true
  const value = String(password).trim()
  if (!value) return true
  const lowered = value.toLowerCase()
  const placeholders = new Set([
    '********',
    '******',
    '••••••••',
    '••••••',
    '<password>',
    'password',
    'tu contraseña smtp',
  ])
  if (placeholders.has(lowered)) return true
  if ([...value].every((ch) => ch === '*' || ch === '•')) return true
  return false
}

const BASIC_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateTestRecipientEmail(raw) {
  if (raw == null) return { ok: false, error_code: 'RECIPIENT_REQUIRED' }
  const value = String(raw).trim()
  if (!value) return { ok: false, error_code: 'RECIPIENT_REQUIRED' }
  if (value.length > 254) return { ok: false, error_code: 'RECIPIENT_INVALID' }
  if (/\r|\n/.test(value)) return { ok: false, error_code: 'RECIPIENT_INVALID' }
  if (/,|;/.test(value)) return { ok: false, error_code: 'RECIPIENT_INVALID' }
  if ((value.match(/@/g) || []).length !== 1) {
    return { ok: false, error_code: 'RECIPIENT_INVALID' }
  }
  if (!BASIC_EMAIL_RE.test(value)) return { ok: false, error_code: 'RECIPIENT_INVALID' }
  return { ok: true, email: value }
}

export function messageForSmtpError(errorCode) {
  switch (errorCode) {
    case 'PASSWORD_REQUIRED':
      return 'Debe escribir la contraseña real que desea probar'
    case 'SMTP_AUTHENTICATION_FAILED':
      return 'Autenticación SMTP fallida: usuario o contraseña incorrectos'
    case 'SMTP_TLS_FAILED':
      return 'Falló la negociación TLS/SSL con el servidor SMTP'
    case 'SMTP_TIMEOUT':
      return 'Tiempo de espera agotado al conectar con el servidor SMTP'
    case 'SMTP_CONNECTION_FAILED':
      return 'No se pudo conectar al servidor SMTP'
    case 'SMTP_PROTOCOL_ERROR':
      return 'Error de protocolo SMTP'
    case 'SMTP_NOOP_FAILED':
      return 'La autenticación no se completó correctamente (NOOP)'
    case 'SMTP_AUTH_NOT_SUPPORTED':
      return 'El servidor SMTP no soporta autenticación'
    default:
      return 'Prueba SMTP fallida'
  }
}

export function messageForSendTestError(errorCode) {
  switch (errorCode) {
    case 'RECIPIENT_REQUIRED':
      return 'Debe indicar un correo destinatario de prueba'
    case 'RECIPIENT_INVALID':
      return 'El correo destinatario de prueba no es válido'
    case 'SMTP_AUTHENTICATION_FAILED':
      return 'La autenticación SMTP falló.'
    case 'SMTP_CONNECTION_FAILED':
      return 'No fue posible conectar con el servidor SMTP.'
    case 'SMTP_TLS_FAILED':
      return 'Falló la negociación segura TLS.'
    case 'SMTP_RECIPIENT_REJECTED':
      return 'El servidor rechazó el correo destinatario.'
    case 'SMTP_SENDER_REJECTED':
      return 'El servidor rechazó la dirección remitente.'
    case 'SMTP_SEND_FAILED':
      return 'No fue posible enviar el correo de prueba.'
    case 'SMTP_TIMEOUT':
      return 'El servidor SMTP no respondió a tiempo.'
    case 'RATE_LIMITED':
      return 'Demasiados envíos de prueba. Espere unos minutos e intente de nuevo'
    case 'SMTP_CONFIG_MISSING':
      return 'No hay configuración de correo activa'
    default:
      return 'No fue posible enviar el correo de prueba.'
  }
}

/**
 * El éxito requiere response.success === true.
 * Un HTTP 200 sin success=true NO se interpreta como éxito.
 */
export function interpretSmtpTestResponse(httpStatus, body) {
  const data = body && typeof body === 'object' ? body : {}
  if (data.success === true) {
    return {
      ok: true,
      message: data.message || 'Autenticación SMTP exitosa',
    }
  }
  // HTTP 200 con success false (o ausente) = fallo
  const code = data.error_code || (httpStatus >= 400 ? 'SMTP_PROTOCOL_ERROR' : 'SMTP_PROTOCOL_ERROR')
  return {
    ok: false,
    message: data.message || messageForSmtpError(code),
    error_code: data.error_code || null,
  }
}

export function interpretSendTestResponse(httpStatus, body) {
  const data = body && typeof body === 'object' ? body : {}
  if (data.success === true) {
    return {
      ok: true,
      message:
        'Correo de prueba aceptado por el servidor SMTP. Confirma la recepción en la bandeja de entrada o correo no deseado.',
    }
  }
  const code = data.error_code || 'SMTP_SEND_FAILED'
  return {
    ok: false,
    message: data.message || messageForSendTestError(code),
    error_code: data.error_code || null,
  }
}

/** Payload del envío de prueba: nunca incluye smtp_password ni config SMTP. */
export function buildSendTestPayload(recipientEmail) {
  return { recipient_email: recipientEmail }
}
